'use client';

import { EmailLogsTable } from "@/features/emaillogs";

const EmailsLogsPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-6 md:p-8">
      <div className="mx-auto bg-white border border-gray-200 rounded-lg shadow-sm p-6">
        {/* Header */}
        <div>
          <h2 className="text-xl font-semibold text-gray-900">
            Email Logs
          </h2>
          <p className="text-sm text-gray-600 mt-1">
            View, search, and manage all sent and failed email activity.
          </p>
        </div>

        {/* ✅ Table now handles fetch, search, and resend */}
        <EmailLogsTable />
      </div>
    </div>
  );
};

export default EmailsLogsPage;
